import './WorkshopArtwork.css';

// Original, quiet production symbols. Decoration only; never substitute for asset previews.
const symbols = {
  character: (
    <>
      <rect x="5" y="3" width="18" height="22" rx="3" />
      <circle cx="14" cy="10" r="3" />
      <path d="M8 20c0-3.4 2.4-5 6-5s6 1.6 6 5" />
      <path className="workshop-artwork__accent" d="M11 22h6" />
    </>
  ),
  scene: (
    <>
      <rect x="3" y="5" width="22" height="18" rx="3" />
      <path d="m4 20 7-8 6 7 3-4 4 5" />
      <path className="workshop-artwork__fine" d="M9 25h10" />
      <circle className="workshop-artwork__accent" cx="20" cy="10" r="1.5" />
    </>
  ),
  prop: (
    <>
      <path d="m5 9 9-5 9 5v10l-9 5-9-5Zm0 0 9 5 9-5m-9 5v10" />
      <path className="workshop-artwork__accent" d="m10 6 9 5v5" />
      <path className="workshop-artwork__fine" d="m8 18 3 1.7" />
    </>
  ),
};

export default function WorkshopArtwork({ kind = 'character', size = 48, className = '' }) {
  return (
    <svg
      className={`workshop-artwork ${className}`}
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {symbols[kind] || symbols.character}
    </svg>
  );
}
